import { Messages } from '../../../../codegen/Localize';
import { IScheduleInfo } from '../../../../ts/models/IScheduleInfo';
import { scheduleEnable } from '../../../actions/spaces/ScheduleMenuActions';
import { AppState } from '../../../state/AppState';
import { EntityActionNames, IEntityAction } from './IEntityAction';
import { anyDisabledSchedule, userCanEditSchedule } from './IEntityActionHelpers';

export const ScheduleEnableAction: IEntityAction<IScheduleInfo, {}> = {
  name: EntityActionNames.EnableSchedules,
  translateName: Messages.enable_action,
  isVisible: (targetItems: IScheduleInfo[], state: AppState) => {
    return targetItems.length > 0 && userCanEditSchedule(state, targetItems);
  },
  isClickable: (_availableActions: {}, targetItems: IScheduleInfo[]) => {
    return anyDisabledSchedule(targetItems);
  },
  createReduxAction: (targetItems: IScheduleInfo[]) => scheduleEnable(targetItems)
};
